/**
 * User Roles
 *
 * @description To quickly iterate over user roles, use `Object.values(Roles)`
 * or use `ROLES` exported from the same file.
 *
 * @example
 * Roles.ADMIN
 * Roles.REQUESTOR
 * Roles.TASK_OWNER
 * Roles.INTERNAL
 */
export enum Roles {
    ADMIN = 'Admin',
    TASK_OWNER = 'Task Owner',
    REQUESTOR = 'Requestor',
    INTERNAL = 'Siemens Internal User'
}

/**
 * Array of all `Roles` - Can be used to verify that a user-provided value is a
 * valid Roles enum value.
 *
 * @example
 *
 * ROLES.includes('Admin'); // true
 * ROLES.includes('Some Other Role'); // false
 */
export const ROLES = Object.values(Roles);
